import ajax from "../assets/uilt/ajax";

let wantedPerson = {
  // List of Wanted Persons

  /**getWantedById */
  getWantedById: req => {
    return ajax.get({
      url: "/back/wanted/get-wanted-by-id",
      param: req.param,
      success: req.success
    });
  },

  /**getWantedPage */
  getWantedPage: req => {
    return ajax.get({
      url: "/back/wanted/get-wanted-page",
      param: req.param,
      success: req.success
    });
  },

  /** getPPEPage */
  getPPEPage: req => {
    return ajax.get({
      url: "/back/wanted/get-ppe-page",
      param: req.param,
      success: req.success
    });
  },

  /**addWantedPersonsApply*/
  addWantedApply: req => {
    return ajax.post({
      url: "/back/wanted/add-wantedApply",
      param: req.param,
      success: req.success
    });
  },
  /**审核渠道充值、提现 */
  updateWantedApply: req => {
    return ajax.post({
      url: "/back/wanted/update-wanted-apply",
      param: req.param,
      success: req.success
    });
  },

  /**Wanted person list、平台查询酬金统计Excel导出 */
  wantedPersonDetailedExport: "/back/wanted/wanted-detailed-export"
};

export default wantedPerson;
